import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { Props } from './types.js';

/** Control `<Icon>` component. */
export const Icon = ({ className, ...props }: Props): ReactElement => (
  <svg
    className={twMerge('h-[75px] w-[75px] fill-current', className)}
    role='img'
    viewBox='0 0 75 75'
    {...props}
  >
    <path d='M75 37.5c0 .1 0 .2-.1.3 0 .1-.1.2-.2.2l-11 11c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1l9.8-9.8H38.2v34.2l9.8-9.8c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1L38 74.7c-.1.1-.2.1-.2.2-.1 0-.2.1-.3.1-.1 0-.2 0-.3-.1-.1 0-.2-.1-.2-.2l-11.1-11c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l9.8 9.8V38.2H2.5l9.8 9.8c.3.3.3.8 0 1.1-.3.3-.8.3-1.1 0L.3 38c-.1-.1-.1-.2-.2-.2 0-.1-.1-.2-.1-.3s0-.2.1-.3c0-.1.1-.2.2-.2l11-11c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-9.8 9.8h34.2V2.5L27 12.3c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1L37 .3c.1-.1.2-.1.2-.2.2-.1.4-.1.6 0 .1 0 .2.1.2.2l11 11c.3.3.3.8 0 1.1s-.8.3-1.1 0l-9.8-9.8v34.2h34.2L62.5 27c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0L74.7 37c.1.1.1.2.2.2 0 .1.1.2.1.3z' />
  </svg>
);
